export const CHALLENGE = {
    LOADER: "challenge-loader",
    IFRAME: "challenge-iframe",
};
